import { supabase } from '../supabaseClient';

export const getTopImagesByPlayerIds = async (playerIds) => {
  if (!playerIds || playerIds.length === 0) return [];

  const { data, error } = await supabase.rpc('get_top_images_by_player_ids', {
    p_ids: playerIds,
  });

  if (error) {
    console.error('이미지 로드 중 오류 발생:', error);
    return [];
  }

  // 응답 데이터 검증
  if (!Array.isArray(data)) {
    console.error('예상치 못한 응답 형식:', data);
    return [];
  }

  return data.length > 0 ? data : [];
};

export const getTopImageByPlayerId = async (playerId) => {
  if (!playerId) return null;

  const { data, error } = await supabase.rpc('get_top_images_by_player_ids', {
    p_ids: [playerId],
  });

  if (error) {
    console.error('이미지 로드 중 오류 발생:', error);
    return null;
  }

  // 응답 데이터 검증
  if (!Array.isArray(data)) {
    console.error('예상치 못한 응답 형식:', data);
    return null;
  }

  return data.length > 0 ? data[0] : null;
};

/**
 * 플레이어의 모든 faceOn 이미지를 조회합니다.
 * @param {string} playerName - 선수명
 * @param {string} team - 팀명
 * @returns {Promise<Array>} usage_count 내림차순으로 정렬된 이미지 목록 (is_blocked=false만)
 */
export const getPlayerFaceOns = async (playerName, team) => {
  if (!playerName || !team) return [];

  const playerId = `${playerName}-${team}`;
  const { data, error } = await supabase
    .from('player_images')
    .select('id, image_url, uploader_id')
    .eq('player_id', playerId)
    .eq('is_blocked', false)
    .order('usage_count', { ascending: false });

  if (error) {
    console.error('플레이어 faceOn 조회 중 오류:', error);
    return [];
  }

  // 응답 데이터 검증
  if (!Array.isArray(data)) {
    console.error('예상치 못한 응답 형식:', data);
    return [];
  }

  return data;
};